import { useMsal } from '@azure/msal-react';
import { authSliceActions } from '@Store/slices/authSlice';

import { useAppDispatch } from '.';

export interface ReturnValue {
  logout: () => void;
}

const useLogout = (): ReturnValue => {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  const logout = (): void => {
    instance.logoutRedirect({ postLogoutRedirectUri: '/' });

    dispatch(authSliceActions.setAuthToken(''));
    sessionStorage.removeItem('redirectURL');
  };

  return { logout };
};

export default useLogout;
